//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';

export default {
  name: 'FreeHeroPartner',
  props: {
    partnerData: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapState({
      isMember: state => state.user.isLoggedIn,
    }),
    ctaUrl() {
      const url = _.get(this.partnerData, 'cta.url');
      if (url) {
        return this.$link(url).url();
      }
      return null;
    },
    logoUrl() {
      return 'https://static.moele.me/img/logo/MotionElements-logo-masthead-220503.svg';
    },
    partnerLogoUrl() {
      return _.get(this.partnerData, 'logo.url', null);
    },
  },
};
